export const services = [
  {
    _id: 0,
    title: "Paints Manufacturing",
    image: "/icons/icon-3.jfif",
    descrption:
      "Are you looking to transform your living or working environment with a fresh coat of paint? Look no further than Paints Manufacturing, your trusted partner in delivering top-notch paints and coatings for all your interior and exterior needs.",
  },
  {
    _id: 1,
    title: "Paints Distribution",
    image: "/icons/icon-distribution.jfif",
    descrption:
      "At Rich Paints Ltd, we take pride in being a leading provider of paints distribution services. We understand the importance of having access to a wide range of top-quality paints for your residential, commercial, or industrial painting projects.",
  },
  {
    _id: 2,
    title: "Technical Support & Customer Service",
    image: "/new/images/old-brushes.jpg",
    descrption:
      "At Rich Paints Ltd, we understand that a successful painting experience goes beyond providing top-quality paints. That's why we offer dedicated Technical Support and Customer Service to ensure your satisfaction throughout your paint journey.",
  },
  {
    _id: 3,
    title: "Color Consultation",
    image: "/icons/icon-consult.jfif",
    descrption:
      "We understand that choosing the right colors for your home or business is a crucial step in creating a captivating and harmonious environment. Our Color Consultation service is designed to help you unlock the power of color, making your space come alive with style, personality, and visual appeal.",
  },
  {
    _id: 4,
    title: "Custom Color Matching",
    image: "/icons/icon-custom.jfif",
    descrption:
      "At Rich Paints Ltd, we understand that sometimes you need a paint color that is truly one-of-a-kind, tailored to your specific requirements and design vision. Our Custom Color Matching service is here to transform your imagination into reality, ensuring that you have the exact color you desire.",
  },
  {
    _id: 5,
    title: "Training & Education",
    image: "/icons/icon-train.jfif",
    descrption:
      "At Rich Paints Ltd, we believe that education and training are key to achieving paint excellence. Our Training and Education programs are designed to empower individuals and professionals with the knowledge, skills, and expertise necessary to excel in the world of paints and coatings.",
  },
  {
    _id: 6,
    title: "Supply Chain Support",
    image: "/icons/icon-supply.jfif",
    descrption:
      "At Rich Paints Ltd, we understand the critical role that a well-managed supply chain plays in the success of your paint-related projects. Our Supply Chain Support services are designed to streamline and optimize your paint supply process, ensuring seamless operations and reliable product availability.",
  },
];
